import React, { useState } from "react";
import {FaMinus, FaPlus,FaShieldAlt, FaUsers, FaLock, FaKey, FaFingerprint, FaUserShield, FaDatabase, FaServer,FaUserSecret,FaUserCheck, FaIdCard, FaMobileAlt, FaUserCog } from "react-icons/fa";

import Medpalm from "../../../assests/HealthcareDataSecurity/AccessControl.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        title: "Role-Based Access Control (RBAC)",
        description:
          "RBAC assigns permissions to users based on their job role, ensuring that healthcare professionals can access only the data necessary for their responsibilities. For example, a nurse may view patient vitals and medication history but not billing records, while an administrator can access financial data but not medical diagnoses. This minimizes the risk of unauthorized access and enhances data security while maintaining workflow efficiency."
      },
      {
        title: "Multi-Factor Authentication (MFA)",
        description:
          "MFA enhances security by requiring multiple forms of verification before granting access to healthcare systems. This typically includes a combination of factors such as a password (something the user knows), a smartphone-generated code (something the user has), or biometric verification (something the user is). MFA protects against password theft, phishing attacks, and unauthorized logins, ensuring that even if one credential is compromised, the system remains secure."
      },
      {
        title: "Single Sign-On (SSO)",
        description:
          "SSO simplifies access management by allowing healthcare staff to log in once and gain access to multiple applications without needing to re-enter credentials. This reduces password fatigue, improves efficiency, and minimizes security risks associated with weak or reused passwords. For example, a doctor can log in once to access EHR systems, telemedicine platforms, and prescription databases securely, streamlining their workflow."
      },
      {
        title: "Biometric Authentication",
        description:
          "Biometric authentication uses unique physical characteristics such as fingerprints, facial recognition, or iris scans to verify a user's identity. This method is more secure than passwords, as biometric data cannot be easily replicated or stolen. In healthcare, biometric authentication ensures that only authorized personnel can access sensitive patient records, medication dispensary systems, and restricted areas in hospitals."
      },
      {
        title: "Audit Trails & Logging",
        description:
          "Audit trails track and log all system access attempts, changes, and user activities, providing a transparent record of who accessed what information and when. This is crucial for regulatory compliance (such as HIPAA and GDPR) and helps detect suspicious activities, unauthorized access attempts, or potential data breaches. Detailed logs also assist in forensic investigations in case of security incidents."
      },
      {
        title: "Zero Trust Security Model",
        description:
          "The Zero Trust Security Model follows the principle of 'never trust, always verify,' meaning no user or device is automatically granted access. Instead, strict authentication and continuous monitoring are applied to ensure that users have the appropriate permissions at all times. This approach minimizes insider threats, prevents unauthorized lateral movement within a network, and enhances overall healthcare cybersecurity resilience."
      }
    ];
const features = [
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "RBAC ensures only authorized personnel access critical data." },
    { icon: <FaFingerprint className="text-[#2a627a] text-lg" />, text: "Biometric authentication enhances security and user identity verification." },
    { icon: <FaKey className="text-[#2a627a] text-lg" />, text: "Encryption-based access control secures medical records and devices." },
    { icon: <FaLock className="text-[#2a627a] text-lg" />, text: "HIPAA-compliant access policies prevent unauthorized data breaches." },
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "MFA adds an extra layer of security to prevent unauthorized logins." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Real-time monitoring detects and responds to security threats." }
];

const benefits = [
    { icon: <FaIdCard className="text-[#2a627a] text-lg" />, text: "Prevents unauthorized access to patient records and sensitive data." },
    { icon: <FaDatabase className="text-[#2a627a] text-lg" />, text: "Secures hospital databases and electronic health records (EHRs)." },
    { icon: <FaMobileAlt className="text-[#2a627a] text-lg" />, text: "Supports secure access to telehealth services and mobile healthcare apps." },
    { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "Restricts physical and digital access to critical IT infrastructure." },
    { icon: <FaUserSecret className="text-[#2a627a] text-lg" />, text: "Reduces insider threats by limiting access based on necessity." },
    { icon: <FaUsers className="text-[#2a627a] text-lg" />, text: "Improves staff efficiency by streamlining access to required resources." }
];
const cmsFeatures = [
    { icon: <FaUserCog className="text-[#2a627a] text-lg" />, text: "IT Security Administrator – Manages access control policies and permissions." },
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Compliance Officer – Ensures adherence to HIPAA and GDPR regulations." },
    { icon: <FaFingerprint className="text-[#2a627a] text-lg" />, text: "Biometric Security Engineer – Develops fingerprint and facial recognition systems." },
    { icon: <FaServer className="text-[#2a627a] text-lg" />, text: "Network Security Analyst – Monitors access logs and detects security threats." },
    { icon: <FaKey className="text-[#2a627a] text-lg" />, text: "Healthcare Access Manager – Assigns role-based permissions for hospital staff." },
    { icon: <FaShieldAlt className="text-[#2a627a] text-lg" />, text: "Identity & Access Management (IAM) Specialist – Oversees authentication systems." }
];

const AccessControl = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Access Control in Healthcare - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Access Control ensures that only authorized users can access sensitive healthcare data, enhancing security and compliance."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Access Control?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Access control is a security mechanism that regulates who can view, edit, or share sensitive healthcare data. It ensures that only authorized personnel—such as doctors, nurses, and administrators—can access specific patient records and medical systems.

At HIKEHEALTH GS, we provide robust access control solutions to protect electronic health records (EHRs), telemedicine platforms, and medical devices from unauthorized access and cyber threats.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in AccessControl
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default AccessControl;
